import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const BondRatingProcessPayloadSchema = z.object({
    bondRating: z.string().optional(),
});

export class BondRatingProcessPayload extends FromSchema(BondRatingProcessPayloadSchema) {
    bondRating?: string;
}
